app.controller('eWaybillViewCtrl', function ($rootScope, $scope, _API_URL, $state, $window, shareData, modalFactory, modalService, $filter, urlServices, _VAR_GLOBAL, toaster, $location) {

    function getReasonList(result) {
        return (result || []).filter(function (item) {
            return item && item.reasonName;
        });
    }

    function chooseReprintReason(title, callback) {
        urlServices.ambilData('api/e-waybill/reprint-reasons', {}, function (err, result) {
            var reasons;

            if (err) {
                return callback(err.err || err || 'Master reason print tidak dapat dimuat');
            }

            reasons = getReasonList(result);
            if (!reasons.length) {
                return callback('Master reason print belum tersedia');
            }

            modalFactory.open('sm', 'modal.ewaybill-reprint-reason.html', 'modalEWaybillReprintReasonCtrl', {
                title: title,
                reasons: reasons
            }).result.then(function (selection) {
                return callback(null, selection && selection.reasonName ? selection.reasonName : '');
            }, function () {
                return callback(null, null);
            });
        });
    }

    function getEWaybillListAwb(row) {
        return row ? (row.AWB || row.NoBukti || '') : '';
    }

    function chooseDeleteReason(title, awb, callback) {
        modalFactory.open('md', 'modal.delete-awb-reason.html', 'modalDeleteAwbReasonCtrl', {
            title: title,
            entryLabel: 'E-Waybill',
            awb: awb
        }).result.then(function (payload) {
            return callback(null, payload && payload.reason ? payload.reason : '');
        }, function () {
            return callback(null, null);
        });
    }

    function clearBatchSelection() {
        $scope.batchSelection = {};
        $scope.batchSelectionData = {};
        $scope.batchSelectAll = false;
        $scope.selectedBatchCount = 0;
    }

    function syncBatchSelectionState() {
        var rows = $scope.dataList && $scope.dataList.data ? $scope.dataList.data : [];
        var totalSelectable = 0;
        var totalSelectedInCurrentPage = 0;

        angular.forEach(rows, function (row) {
            var awb = getEWaybillListAwb(row);

            if (!awb) {
                return;
            }

            totalSelectable += 1;
            if ($scope.batchSelection[awb]) {
                totalSelectedInCurrentPage += 1;
                // Update cache data
                $scope.batchSelectionData[awb] = row;
            }
        });

        // Hitung total terpilih dari seluruh halaman
        var totalSelectedGlobal = 0;
        angular.forEach($scope.batchSelection, function(val) {
            if (val) totalSelectedGlobal += 1;
        });

        $scope.selectedBatchCount = totalSelectedGlobal;
        $scope.batchSelectAll = totalSelectable > 0 && totalSelectedInCurrentPage === totalSelectable;
    }

    function getSelectedBatchRows() {
        var selectedRows = [];
        var rows = $scope.dataList && $scope.dataList.data ? $scope.dataList.data : [];
        
        // Simpan data row yang sedang terpilih di halaman aktif
        angular.forEach(rows, function(row) {
            var awb = getEWaybillListAwb(row);
            if (awb && $scope.batchSelection[awb]) {
                // Gunakan cache untuk memastikan kita punya data row yang lengkap untuk print
                $scope.batchSelectionData[awb] = row;
            }
        });

        // Kembalikan semua data row yang ada di cache batchSelectionData
        angular.forEach($scope.batchSelection, function(selected, awb) {
            if (selected && $scope.batchSelectionData[awb]) {
                selectedRows.push($scope.batchSelectionData[awb]);
            }
        });
        
        return selectedRows;
    }

    function clearBatchRange() {
        $scope.batchRange = {
            startAwb: '',
            endAwb: ''
        };
        $scope.batchRangeLoading = false;
    }

    function getNormalizedBatchRange() {
        return {
            startAwb: String(($scope.batchRange && $scope.batchRange.startAwb) || '').trim().toUpperCase(),
            endAwb: String(($scope.batchRange && $scope.batchRange.endAwb) || '').trim().toUpperCase()
        };
    }

    function sortBatchRowsAscending(rows) {
        return (rows || []).slice().sort(function (left, right) {
            var leftAwb = String(getEWaybillListAwb(left) || '').toUpperCase();
            var rightAwb = String(getEWaybillListAwb(right) || '').toUpperCase();

            if (leftAwb === rightAwb) {
                return 0;
            }
            return leftAwb > rightAwb ? 1 : -1;
        });
    }

    function openControlledPrintWindow(awb) {
        function requestPrint(reason) {
            var printWindow = $window.open('about:blank', '_blank');

            urlServices.simpanData('api/e-waybill/' + encodeURIComponent(awb) + '/request-print', { reason: reason || '' }, function (err, result) {
                if (err) {
                    if (printWindow && !printWindow.closed) {
                        printWindow.close();
                    }
                    return toaster.pop('warning', 'E-Waybill', err.err || err || 'Permintaan print e-waybill gagal');
                }
                if (!result || !result.printUrl) {
                    if (printWindow && !printWindow.closed) {
                        printWindow.close();
                    }
                    return toaster.pop('warning', 'E-Waybill', 'Respons print e-waybill tidak valid');
                }
                if (printWindow && !printWindow.closed) {
                    printWindow.location = result.printUrl;
                } else {
                    $window.location = result.printUrl;
                }
            });
        }

        urlServices.ambilData('api/e-waybill/' + encodeURIComponent(awb) + '/print-status', {}, function (statusErr, statusResult) {
            var summary = (statusResult && statusResult.summary) || {};
            var settings = (statusResult && statusResult.settings) || {};
            var requiresReason = Number(summary.effectiveCount || 0) > 0 && !!settings.requireReprintReason;

            if (statusErr) {
                return requestPrint('');
            }

            if (requiresReason) {
                return chooseReprintReason('Pilih alasan reprint e-waybill', function (reasonErr, reason) {
                    if (reasonErr) {
                        return toaster.pop('warning', 'E-Waybill', reasonErr);
                    }
                    if (reason === null) {
                        return;
                    }
                    return requestPrint(reason || '');
                });
            }

            return requestPrint('');
        });
    }

    function openControlledBatchPrintWindow(rows) {
        var selectedRows = sortBatchRowsAscending(rows || []);
        var awbs = selectedRows.map(getEWaybillListAwb).filter(function (awb, index, array) {
            return !!awb && array.indexOf(awb) === index;
        });
        var requiresReason = selectedRows.some(function (row) {
            return Number(row && row.PrintCount || 0) > 0;
        });
        var printWindow;

        function requestBatchPrint(reason) {
            printWindow = $window.open('about:blank', '_blank');

            urlServices.simpanData('api/e-waybill/request-print-batch', {
                awbs: awbs,
                reason: reason || ''
            }, function (err, result) {
                var failureText;

                if (err) {
                    if (printWindow && !printWindow.closed) {
                        printWindow.close();
                    }
                    return toaster.pop('warning', 'E-Waybill', err.err || err || 'Permintaan batch print e-waybill gagal');
                }
                if (!result || !result.printUrl) {
                    if (printWindow && !printWindow.closed) {
                        printWindow.close();
                    }
                    return toaster.pop('warning', 'E-Waybill', 'Respons batch print e-waybill tidak valid');
                }

                if (result.failedItems && result.failedItems.length) {
                    failureText = result.failedItems.map(function (item) {
                        return (item.awb || '-') + ': ' + (item.err || 'gagal');
                    }).join(' | ');
                    toaster.pop('warning', 'Batch Print', 'Sebagian AWB dilewati. ' + failureText);
                }

                if (printWindow && !printWindow.closed) {
                    printWindow.location = result.printUrl;
                } else {
                    $window.location = result.printUrl;
                }

                clearBatchSelection();
            });
        }

        if (!awbs.length) {
            return toaster.pop('warning', 'E-Waybill', 'Pilih minimal 1 AWB');
        }
        if (requiresReason) {
            return chooseReprintReason('Pilih alasan reprint untuk batch e-waybill', function (reasonErr, reason) {
                if (reasonErr) {
                    return toaster.pop('warning', 'E-Waybill', reasonErr);
                }
                if (reason === null) {
                    return;
                }
                return requestBatchPrint(reason || '');
            });
        }

        return requestBatchPrint('');
    }

    $scope.deleteAuthorized = false;
    $scope.managePrintSettingsAuthorized = false;
    $scope.activePrintSettings = null;
    $scope.filter = '';
    $scope.batchSelection = {};
    $scope.batchSelectionData = {};
    $scope.batchSelectAll = false;
    $scope.selectedBatchCount = 0;
    $scope.batchRange = {
        startAwb: '',
        endAwb: ''
    };
    $scope.batchRangeLoading = false;
    $scope.dataList = {
        totalItems: 0,
        summary: {},
        data: []
    };
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: _VAR_GLOBAL.limit,
        sort: null
    };
    $scope.perTglP = {
        startDate: moment().subtract(30, 'days'),
        endDate: moment()
    };

    $scope.edit = function (dt) {
        var awb = getEWaybillListAwb(dt);

        if (!awb) {
            return toaster.pop('warning', 'E-Waybill', 'No AWB tidak boleh kosong');
        }
        return window.location = '/e-waybill-entry?awb=' + encodeURIComponent(awb) + '&isedit=true';
    };

    $scope.preview = function (row) {
        var awb = getEWaybillListAwb(row);

        if (!awb) {
            return toaster.pop('warning', 'E-Waybill', 'No AWB tidak boleh kosong');
        }
        window.open('/e-waybill-print?awb=' + encodeURIComponent(awb), '_blank');
    };

    $scope.print = function (row) {
        var awb = getEWaybillListAwb(row);

        if (!awb) {
            return toaster.pop('warning', 'E-Waybill', 'No AWB tidak boleh kosong');
        }
        openControlledPrintWindow(awb);
    };

    $scope.isBatchSelected = function (row) {
        var awb = getEWaybillListAwb(row);
        return !!(awb && $scope.batchSelection[awb]);
    };

    $scope.toggleBatchSelection = function (row) {
        var awb = getEWaybillListAwb(row);

        if (!awb) {
            return;
        }

        if ($scope.batchSelection[awb]) {
            $scope.batchSelection[awb] = true;
        } else {
            delete $scope.batchSelection[awb];
        }

        syncBatchSelectionState();
    };

    $scope.toggleAllBatchSelection = function () {
        var shouldSelectAll = !!$scope.batchSelectAll;

        angular.forEach($scope.dataList.data || [], function (row) {
            var awb = getEWaybillListAwb(row);

            if (!awb) {
                return;
            }

            if (shouldSelectAll) {
                $scope.batchSelection[awb] = true;
            } else {
                delete $scope.batchSelection[awb];
            }
        });

        syncBatchSelectionState();
    };

    $scope.clearBatchRange = function () {
        clearBatchRange();
    };

    $scope.batchPrintSelected = function () {
        var range = getNormalizedBatchRange();

        if ($scope.batchRangeLoading) {
            return;
        }

        if (range.startAwb || range.endAwb) {
            if (!range.startAwb || !range.endAwb) {
                return toaster.pop('warning', 'E-Waybill', 'Isi nomor e-waybill awal dan akhir untuk batch print range');
            }

            $scope.batchRangeLoading = true;
            return urlServices.ambilData('api/e-waybill/print-range?start_awb=' + encodeURIComponent(range.startAwb) + '&end_awb=' + encodeURIComponent(range.endAwb), {}, function (err, result) {
                var rows = result && result.data ? result.data : [];

                $scope.batchRangeLoading = false;
                if (err) {
                    return toaster.pop('warning', 'E-Waybill', err.err || err || 'Range batch print e-waybill tidak valid');
                }
                if (!rows.length) {
                    return toaster.pop('warning', 'E-Waybill', 'Data e-waybill pada range tersebut tidak ditemukan');
                }
                return openControlledBatchPrintWindow(rows);
            });
        }

        return openControlledBatchPrintWindow(getSelectedBatchRows());
    };

    $scope.loadPrintSettings = function () {
        if (!$scope.managePrintSettingsAuthorized) {
            return;
        }

        urlServices.ambilData('api/e-waybill/print-settings', {}, function (err, result) {
            if (!err && result) {
                $scope.activePrintSettings = result;
            }
        });
    };

    $scope.openPrintSettings = function () {
        if (!$scope.managePrintSettingsAuthorized) {
            return toaster.pop('warning', 'E-Waybill', 'Anda tidak memiliki akses setting print e-waybill');
        }

        modalFactory.open('md', 'modal.ewaybill-print-settings.html', 'modalEWaybillPrintSettingsCtrl', {
            settings: angular.copy($scope.activePrintSettings || {})
        }).result.then(function (savedSettings) {
            if (savedSettings) {
                $scope.activePrintSettings = savedSettings;
            }
        });
    };

    $scope.hapus = function (row) {
        var awb = getEWaybillListAwb(row);

        if (!awb) {
            return toaster.pop('warning', 'E-Waybill', 'No AWB tidak boleh kosong');
        }
        if (!$scope.deleteAuthorized) {
            return toaster.pop('warning', 'E-Waybill', 'Anda tidak memiliki otoritas hapus e-waybill');
        }

        chooseDeleteReason('Alasan Hapus E-Waybill', awb, function (reasonErr, reasonText) {
            if (reasonErr) {
                return toaster.pop('error', 'E-Waybill', reasonErr);
            }
            if (!reasonText) {
                return;
            }

            urlServices.hapusData('api/e-waybill/' + encodeURIComponent(awb) + '?deleteReason=' + encodeURIComponent(reasonText), {
                reason: reasonText
            }, function (err) {
                if (err) {
                    return toaster.pop('error', 'E-Waybill', err.err || err || 'Data e-waybill gagal dihapus');
                }

                toaster.pop('success', 'E-Waybill', awb + ' berhasil dihapus');
                $scope.viewData($scope.paginationOptions.pageNumber || 1);
            });
        });
    };

    $scope.viewData = function (pg) {
        $scope.paginationOptions.pageNumber = pg;
        $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter);
    };

    $scope.getData = function (pageSize, page, searchText) {
        setTimeout(function () {
            var ft = encodeURIComponent(String(searchText || '').trim());
            var data = 'limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, 'yyyy-MM-dd') + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, 'yyyy-MM-dd') + '&is_e_waybill=1';

            if (searchText) {
                data = 'term=' + ft + '&' + data;
            }

            urlServices.ambilData('api/e-waybill/filter?' + data, {}, function (err, sukses) {
                if (err) {
                    toaster.pop('error', 'Error', err.err || err);
                    $scope.dataList.totalItems = 0;
                    $scope.dataList.data = [];
                    // clearBatchSelection(); // Jangan di-clear saat ganti halaman
                } else {
                    $scope.dataList.totalItems = sukses.records;
                    $scope.dataList.data = sukses.data;
                    // clearBatchSelection(); // Jangan di-clear saat ganti halaman
                    syncBatchSelectionState(); // Sinkronisasi ulang untuk halaman baru
                }
            });
        }, 100);
    };

    $scope.clearSelection = function() {
        clearBatchSelection();
    };

    $scope.$watch('perTglP', function () {
        $scope.viewData(1);
    }, false);

    urlServices.ambilData('api/e-waybill/defaultdata', {}, function (err, result) {
        if (!err && result) {
            $scope.deleteAuthorized = !!(result.canDeleteEWaybill || result.canDeleteOutbound);
            $scope.managePrintSettingsAuthorized = !!result.canManageEWaybillPrintSettings;
            if ($scope.managePrintSettingsAuthorized) {
                $scope.loadPrintSettings();
            }
        }
    });
});